export default __webpack_public_path__ + "static/bg2-ffa83d249a2c440d146d8371dda2ddc6.png";